import type React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAccount } from "wagmi";
import { ConnectButton } from "@rainbow-me/rainbowkit";

export function Navbar() {
  const navigate = useNavigate();
  const { isConnected } = useAccount();

  return (
    <header
      className="h-14 sticky top-0 z-50 border-b border-white/8 px-4 md:px-6 flex items-center gap-3 md:gap-8"
      style={{ background: "#0e1a2a" }}
    >
      {/* Left: logo */}
      <Link to="/" className="font-display text-xl spectral-gradient-text shrink-0">
        Espectro
      </Link>

      <div className="flex-1" />

      {/* Right */}
      <div className="flex items-center gap-2 shrink-0">
        {isConnected ? (
          <>
            {/* Desktop: full address pill */}
            <div className="hidden md:block" style={{ "--rk-colors-connectButtonBackground": "#191f30" } as React.CSSProperties}>
              <ConnectButton accountStatus="address" chainStatus="icon" showBalance={false} />
            </div>

            {/* Mobile: circular account icon */}
            <div className="md:hidden">
              <ConnectButton.Custom>
                {({ openAccountModal, mounted }) => {
                  if (!mounted) return null;
                  return (
                    <button
                      onClick={openAccountModal}
                      className="w-8 h-8 rounded-full flex items-center justify-center border border-spectral-violet/30 hover:border-spectral-violet/60 transition-colors"
                      style={{ background: "rgba(124,58,237,0.15)" }}
                      aria-label="Account"
                    >
                      <svg width="15" height="15" viewBox="0 0 16 16" fill="none" className="text-spectral-violet">
                        <circle cx="8" cy="5.5" r="2.5" stroke="currentColor" strokeWidth="1.3" />
                        <path d="M2.5 14C2.5 11.515 5.015 9.5 8 9.5C10.985 9.5 13.5 11.515 13.5 14" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
                      </svg>
                    </button>
                  );
                }}
              </ConnectButton.Custom>
            </div>

            {/* Gear / Recovery — both sizes */}
            <button
              onClick={() => navigate("/app/recovery")}
              className="relative p-1.5 border border-border rounded text-ash hover:border-mist hover:text-mist transition-all"
              aria-label="Recovery"
              title="Recovery"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M6.5 1.5H9.5L9.9 3.4C10.3 3.5 10.7 3.7 11 3.9L12.8 3.2L14.3 5.8L12.8 7.1C12.8 7.4 12.8 7.6 12.8 7.9L14.3 9.2L12.8 11.8L11 11.1C10.7 11.3 10.3 11.5 9.9 11.6L9.5 13.5H6.5L6.1 11.6C5.7 11.5 5.3 11.3 5 11.1L3.2 11.8L1.7 9.2L3.2 7.9C3.2 7.6 3.2 7.4 3.2 7.1L1.7 5.8L3.2 3.2L5 3.9C5.3 3.7 5.7 3.5 6.1 3.4L6.5 1.5Z"
                  stroke="currentColor"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="8" cy="7.5" r="2" stroke="currentColor" strokeWidth="1.2" />
              </svg>
            </button>
          </>
        ) : (
          <ConnectButton.Custom>
            {({ openConnectModal, mounted }) => (
              <button
                onClick={openConnectModal}
                disabled={!mounted}
                className="px-4 py-1.5 rounded-lg text-white font-heading text-sm font-semibold hover:brightness-110 transition-all"
                style={{ background: "#3b83da" }}
              >
                Connect Wallet
              </button>
            )}
          </ConnectButton.Custom>
        )}
      </div>
    </header>
  );
}
